const digitLengthOf = (value) => value.replaceAll(/\D/g, "").length;

export const rules = {
    username: [(value) => !/[^a-z\d]/.test(value) || "아이디를 영문 소문자 및 숫자로만 작성해주세요", (value) => (value && value?.length > 3) || "아이디를 4자 이상으로 작성해주세요"],

    password: [(value) => /[~!@#$%^&*()_+|<>?:{}]/.test(value) || "비밀번호에 특수문자를 넣어주세요", (value) => /[a-zA-Z]/.test(value) || "비밀번호에 영문을 넣어주세요", (value) => /[0-9]/.test(value) || "비밀번호에 숫자를 넣어주세요", (value) => (value && 8 <= value.length && value.length <= 16) || "비밀번호를 8 ~ 16자 사이로 작성해주세요"],

    name: [(value) => (value && 1 < value?.length) || "이름을 입력해주세요"],

    email: [(value) => (value && /[^@]+@[^@]+\.[^@]+/.test(value)) || "이메일을 입력해주세요"],

    phone: [(value) => (value && [3, 8].includes(digitLengthOf(value))) || "연락처를 입력해주세요"],
};

export const rules_en = {
    username: [(value) => !/[^a-z\d]/.test(value) || "Please write your ID in English lowercase letters and numbers only", (value) => (value && value?.length > 3) || "Please write your ID with 4 characters or more"],

    password: [(value) => /[~!@#$%^&*()_+|<>?:{}]/.test(value) || "Please include special characters in your password", (value) => /[a-zA-Z]/.test(value) || "Please enter English in the password", (value) => /[0-9]/.test(value) || "Please enter a number in your password", (value) => (value && 8 <= value.length && value.length <= 16) || "Please enter a password between 8 and 16 characters"],

    name: [(value) => (value && 1 < value?.length) || "Input your name, please"],

    email: [(value) => (value && /[^@]+@[^@]+\.[^@]+/.test(value)) || "Please enter your e-mail"],

    phone: [(value) => (value && [3, 8].includes(digitLengthOf(value))) || "Please enter your contact information"],
};